import React from 'react'
import dynamic from 'next/dynamic'

import {LazyLoad} from '@lib/LazyLoad'
import Meta from '@components/Meta'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const GetStarted = dynamic(() => import('@components/GetStarted'))

export default function VendorPolicyPrivacy() {
  return (
    <React.Fragment>
      <Meta title='Vendor Privacy Policy – Data Science Consultant Thailand | Data Wow in Bangkok' />

      <div className='Document'>
        <div className='Document__hero'>
          <div className='container'>
            <h1>
              Vendor Privacy <span>Policy</span>
            </h1>

            <div>
              <p>
                When collaborating with Data Wow Co., Ltd,. ("Data Wow" or
                "We"), your personal data is processed in order to carry our
                daily agreed operations and requirements. In the framework of
                the processing operations, we ensure that your data is protected
                according to the highest standards, namely in accordance with
                respective laws and the provision of the Personal Data
                Protection Act B.E. 2562 (the
                <strong>"PDPA"</strong>). This Privacy Policy describes the ways
                in which Data Wow processes, protects, and ensures your rights
                as a data subject.
              </p>
            </div>
          </div>
        </div>

        <div className='Document__divider'></div>
        <div className='Document__content'>
          <div className='container'>
            <h3>Collection of Personal Data</h3>
            <p>
              We may collect your personal data that receive directly from you
              when you register your account on our website, provide us personal
              data necessary to enter into a contract, during the performance of
              your services for Data Wow, the questionnaire, telephone number,
              email address or other contact channels. We may also collect your
              personal data that we can access from the other source not
              directly from you such as search engines, social media, government
              authorities, third parties, etc.
            </p>
            <hr />

            <h3>Types of Data Collected</h3>
            <p>
              The primary reason we process your personal data is to approve,
              manage, administer or effect an agreement between Data Wow and the
              company you represent or work for. In this respect, we use your
              personal data, i.e., to organize our sourcing activities, issue
              purchase orders, process payments, perform accounting, manage our
              contract review the services or products you supply us with and
              other relevant activities.
            </p>

            <p>
              In addition, we process personal data to meet our legal
              obligations (such as record keeping obligations, screening duties
              of board members), as well as to manage our risks and operations
              (e.g. prevent and detect security threats, exercise or defend
              legal claims
            </p>

            <ul>
              <li>
                The personal data we collect from you is any information that
                can be used to personally identify you, either directly or
                indirectly, including but not limited to the following
                information;
              </li>
              <li>
                Personal details e.g., Name, Surname, Age, Date of Birth,
                Nationality, Identification Card, Passport, etc.
              </li>
              <li>
                Contact details e.g., Mailing address, Phone number, E-mail
                address, etc.
              </li>
              <li>
                Account details e.g., Username, Password, Transactions History,
                etc.
              </li>
              <li>
                Proof of identity e.g., copy of identification card, copy of
                passport, etc.
              </li>
              <li>
                Transaction and Financial information e.g., Bank Account, etc
              </li>
              <li>
                Technical Data e.g., IP Address, Cookie ID, Activity Log, etc.
              </li>
              <li>
                Including other information e.g., Picture, Motion Picture and
                any other information that is considered personal data under the
                Personal Data Protection Laws.
              </li>
            </ul>

            <p>
              We may collect, use or disclose your sensitive personal data that
              is specially categorized by law when we have obtained explicit
              consent from you or where necessary for us as permissible under
              law. We may collect, use or disclose your sensitive personal data
              such as health data, religion, biometric data such as facial
              recognition data, iris recognition data, fingerprint recognition
              data and any data which may affect the data subject in the same
              manner, as prescribed by the Personal Data Protection Committee.
            </p>
            <hr />

            <h3>Storage of Data</h3>
            <p>
              We will keep your personal data in document and electronic form.
              We store your personal information on our company’s server in
              Thailand and in Amazon Web Services (AWS) cloud system in
              Singapore.
            </p>
            <hr />

            <h3>Processing of Your Personal Data.</h3>
            <p>
              We will collect, use or disclose your personal data according to
              your request and/ or agreement with us. This includes but is not
              limited to the following purposes:
            </p>
            <ul>
              <li>
                To perform of a contract or taking steps at your request before
                entering into a contract, consider for approval in relation to
                the provision of products and/or services.
              </li>
              <li>
                To contact you with regard to the services provided to Data Wow
                as a vendor.
              </li>
              <li>
                To evaluate your performance for future management and
                collaboration.
              </li>
              <li>
                To create and maintain a database of vendors; to generate
                statistics pertaining to vendors; and to continuously improve
                our services
              </li>
              <li>To process payments for services provided.</li>
              <li>
                To comply with our policies, terms and conditions and respond to
                legal processes or to comply with or as required by the PDPA,
                governmental or regulatory requirements of any relevant
                jurisdiction.
              </li>
            </ul>
            <hr />

            <h3>Legal basis for Processing Your Personal Data</h3>
            <p>
              Data Wow will process your personal data where there is a legal
              basis to do so. In accordance with the PDPA requirements and
              provisions, we will lawfully process your data only:
            </p>
            <ol>
              <li>
                To fulfill an agreement between you, as a vendor, and Data Wow.
              </li>
              <li>To comply with an obligation under applicable laws.</li>
              <li>
                When you have consented to our use of it for a specific purpose.
              </li>
              <li>
                To pursue our legitimate interest (e.g., building security of
                you visit our office, or to protect our IT infrastructure),
                which we consider to be the creation and maintenance of a
                database of vendors; to generate statistics pertaining to
                vendors and clients; and to continuously improve our services:
                we will therefore use your data only for the above purposes as
                long as your interests and fundamental rights do not supersede
                such usage.
              </li>
              <li>
                To protect your vital interests or those of another individual.
              </li>
            </ol>
            <hr />

            <h3>Disclosure of Personal Data</h3>
            <p>
              To protect your personal data from fraud and unauthorized
              transactions. (e.g., Money laundering), litigation and other
              liability. Data Wow may disclose your personal data to others with
              your consent or as permitted by law to third parties including the
              directors, executives, staffs, employees, contractors, agents or
              consultants of Data Wow and our affiliates, business partners,
              service providers and/ or any other person or juristic person
              which we have legal relationship with. This includes but is not
              limited to the following individuals/ organizations:
            </p>
            <hr />

            <h3>Organization</h3>
            <p>
              We may disclose your personal data within our organization to
              provide and develop our products or services. We may combine
              information internally across the different products or services
              covered by this Privacy Policy to help us be more relevant and
              useful to you and others.
            </p>
            <hr />

            <h3>Service Providers</h3>
            <p>
              We may use service providers to help us provide our services such
              as payments, marketing and development of products or services.
              When we engage another company to perform such functions, we may
              provide them with information, including Personal Data, in
              connection with their performance of such functions. Please note
              that service providers have their own privacy policy.
            </p>
            <hr />

            <h3>Business Partners</h3>
            <p>
              In relation with our business partners, we may disclose certain
              personal data to them in order to coordinate and provide our
              products or services to you and provide necessary information
              about the availability of our products or services.
            </p>
            <hr />

            <h3>Business Transfer</h3>
            <p>
              In connection with any reorganization, restructuring, merger or
              acquisition, or other transfer of assets, we may transfer
              information, including certain your personal data, provided that
              the receiving party agrees to respect your personal data in a
              manner that is consistent with this Privacy Policy and the
              Personal Data Protection Laws.
            </p>
            <hr />

            <h3>Cross-border Data Transfer</h3>
            <p>
              We may disclose or transfer your personal data to individuals,
              organizations, or third-party cloud infrastructure provider Amazon
              Web Services (AWS) located at Singapore. We will implement
              security measures to ensure that your personal data is transferred
              to the destination country that provide adequate safeguard or
              other procedure as required by law to protect and maintain your
              personal data.
            </p>
            <hr />

            <h3>Data Retention</h3>
            <p>
              We will retain your personal data for as long as necessary during
              the period we have a relationship with the supplier you represent
              or work for, or for as long as necessary in connection with the
              purposes set out in this Privacy Policy, unless law requires or
              permits a longer retention period. We will erase, destroy or
              anonymize your personal data when it is no longer necessary or
              when the period lapses.
            </p>
            <hr />

            <h3>Data Subject Rights</h3>
            <p>
              When you provide Data Wow with your personal data. You have the
              rights through which you can exercise your rights free of charge,
              under the exception of the law.
            </p>

            <p>
              Subject to the PDPA thereof, you may exercise any of these rights
              in the following:
            </p>

            <ul>
              <li>
                <strong>Right to withdraw consent</strong> : If you have given
                consent to us to collect, use or disclose your personal data
                whether before or after the effective date of the Personal Data
                Protection Laws, you have the right to withdraw such consent at
                any time throughout the period your personal data available to
                us, unless it is restricted by laws or you are still under
                beneficial contract.
              </li>

              <li>
                <strong>Right to access</strong> : You have the right to access
                your personal data that is under our responsibility; to request
                us to make a copy of such data for you; and to request us to
                reveal how we obtain your personal data.
              </li>

              <li>
                <strong>Right to data portability</strong> : You have the right
                to obtain your personal data if we organize such personal data
                in automatic machine-readable or usable format and can be
                processed or disclosed by automatic means; to request us to send
                or transfer the personal data in such format directly to other
                data controllers if doable by automatic means; and to request to
                obtain the personal data in such format sent or transferred by
                us directly to other data controllers unless not technically
                feasible.
              </li>

              <li>
                <strong>Right to objection</strong> : You have the right to
                object to collection, use or disclosure of your personal data at
                any time if such doing is conducted for legitimate interests of
                us, corporation or individual which is within your reasonable
                expectation; or for carrying out public tasks.
              </li>

              <li>
                <strong>Right to erasure or destruction</strong> : You have the
                right to request us to erase, destroy or anonymize your personal
                data if you believe that the collection, use or disclosure of
                your personal data is against relevant laws; or retention of the
                data by us is no longer necessary in connection with related
                purposes under this Privacy Policy; or when you request to
                withdraw your consent or to object to the processing as earlier
                described.
              </li>

              <li>
                <strong>Right to restriction of processing</strong> : You have
                the right to request us to suspend processing your personal data
                during the period where we examine your rectification or
                objection request; or when it is no longer necessary, and we
                must erase or destroy your personal data pursuant to relevant
                laws, but you request us to suspend the processing instead.
              </li>

              <li>
                <strong>Right to rectification</strong> : You have the right to
                rectify your personal data to be updated, complete and not
                misleading.
              </li>

              <li>
                <strong>Right to lodge a complaint</strong> : You have the right
                to complain to competent authorities pursuant to relevant laws
                if you believe that the collection, use or disclosure of your
                personal data is violating or not in compliance with relevant
                laws.
              </li>
            </ul>

            <p>
              You may exercise these rights as the Data Subject by contacting
              our Data Protection Officer as mentioned below. We will notify the
              result of your request within 30 days upon receipt of such
              request. If we deny the request, we will inform you of the reason
              via SMS, email address, telephone, registered mail (if
              applicable).
            </p>
            <hr />

            <h3>Cookies</h3>
            <p>
              To enrich and perfect your experience, we use cookies or similar
              technologies to display personalized content, appropriate
              advertising and store your preferences on your computer. We use
              cookies to identify and track visitors, their usage of our website
              and their website access preferences. If you do not wish to have
              cookies placed on your computer, you should set their browsers to
              refuse cookies before using our website.
            </p>

            <h4>Type of cookies that we use</h4>
            <ul>
              <li>
                <strong>Strictly Necessary Cookies</strong> : Necessary cookies
                allow us to offer you the best possible experience when
                accessing and navigating through our Website and using its
                features. For example, these cookies let us recognize that you
                have created an account and have logged into that account to
                access the content.
              </li>
              <li>
                <strong>Analytical Cookies</strong> : This type of cookie allows
                us to remember and store the error log that occurs during the
                use of platform. In order to improve and correct the operation
                of the website and are used to help us improve user experience
                of the platform. It is also collecting data for statistical
                purposes on the entrance methods and platform browsing behavior
                to improve the operation of the platform by allowing users to
                easily find what they are looking for and help us understand the
                interests of the platform user.
              </li>
              <li>
                <strong>Functionality Cookies</strong> : These cookies let us
                operate the Website and our Services in accordance with the
                choices you make. For example, we will recognize your username
                and remember how you customized the platforms and services
                during future visits and also support reconnection in the event
                of a breakdown or there is a problem during the use of the
                platform.
              </li>
            </ul>
            <hr />

            <h3>Data Security</h3>
            <p>
              We endeavor to protect your personal data by establishing security
              measures in accordance with the principles of confidentiality,
              integrity, and availability to prevent loss, unauthorized or
              unlawful access, destruction, use, alteration, or disclosure
              including administrative safeguard, technical safeguard, physical
              safeguard and access controls. In addition, our staffs, employees,
              business partners and service providers are obliged to maintain
              the confidentiality of your personal data by complying with the
              data security standards and policies when any of personal data is
              being used, transmitted, transferred or processed.
            </p>
            <hr />

            <h3>Data Breach Notification</h3>
            <p>
              We will notify the Office of the Personal Data Protection
              Committee without delay and, where feasible, within 72 hours after
              having become aware of it, unless such personal data breach is
              unlikely to result in a risk to the rights and freedoms of you. If
              the personal data breach is likely to result in a high risk to the
              rights and freedoms of you, we will also notify the personal data
              breach and the remedial measures to you without delay through our
              website, SMS, email address, telephone or registered mail (if
              applicable).
            </p>
            <hr />

            <h3>Changes to this Privacy Policy</h3>
            <p>
              We reserve the right to amend this privacy policy from time to
              time. We will be publishing such changes on this website. Please
              revisit this page periodically for updates or changes to our
              privacy policy. In case of material changes, we will notify you of
              such changes as soon as possible.
            </p>

            <p>
              This Privacy Policy was last updated and effective on May 12, 2021
            </p>
            <hr />

            <h3>Links to Other Sites</h3>
            <p>
              The purpose of this Privacy Policy is to offer products or
              services and use of our website. Any websites from other domains
              found on our site is subject to their privacy policy which is not
              related to us.
            </p>
            <hr />

            <h3>Contact Information</h3>
            <p>
              If you have any questions about this Privacy Policy or would like
              to exercise your rights, you can contact us by using the following
              details:
            </p>

            <p>
              <strong>Data Wow (Thailand) Company Limited</strong>
              <address>
                1778 Summer Hub Office, 6th Floor,
                <br />
                Sukhumvit Road, Phra Khanong,
                <br />
                Khlong Toei, Bangkok 10110 THAILAND
              </address>
            </p>
            <p>
              Website: <a href='https://datawow.co.th'>https://datawow.co.th</a>
              <br />
              Tel: <a href='tel:020245560'>02 024 5560</a>
            </p>
          </div>
        </div>
      </div>

      <LazyLoad>
        <GetStarted />
      </LazyLoad>
    </React.Fragment>
  )
}

VendorPolicyPrivacy.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}
